import { CONFERENCE_JOINED, CONFERENCE_WILL_LEAVE } from '../../../../react/features/base/conference/actionTypes';
import MiddlewareRegistry from '../../../../react/features/base/redux/MiddlewareRegistry';
import { SHARED_VIDEO } from '../../../../react/features/shared-video/constants';
import { SELECTED_LANG_TRANSCRIPTION } from '../../customStorageSettings/actionTypes';
import { sendConferenceDisposeEvent, sendConferenceJoinedEvent, sendKinesisEvent, sendSharedVideoEvent } from './actions';
import { isKinesisLogsEnabled } from './functions';
/**
 * Implements the middleware of the feature analytics/kinesis.
 *
 * @param {Store} store - Redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register((store) => next => action => {
    switch (action.type) {
        case CONFERENCE_JOINED: {
            const result = next(action);
            const { dispatch, getState } = store;
            if (!isKinesisLogsEnabled(getState())) {
                break;
            }
            const { conference } = action;
            if (conference) {
                dispatch(sendConferenceJoinedEvent());
                conference.addCommandListener(SHARED_VIDEO, ({ attributes, tagName }) => {
                    if (tagName === 'shared-video' && (attributes.state === 'start' || attributes.state === 'stop')) {
                        dispatch(sendSharedVideoEvent(attributes.state));
                    }
                });
            }
            return result;
        }
        case CONFERENCE_WILL_LEAVE: {
            const { dispatch, getState } = store;
            if (!isKinesisLogsEnabled(getState())) {
                break;
            }
            dispatch(sendConferenceDisposeEvent());
            break;
        }
        case SELECTED_LANG_TRANSCRIPTION: {
            const { dispatch, getState } = store;
            if (!isKinesisLogsEnabled(getState())) {
                break;
            }
            const { lang } = action;
            dispatch(sendKinesisEvent({
                message: 'transcription enabled',
                language: lang
            }));
        }
    }
    return next(action);
});
